import { Select, Spin } from "antd";
import React from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
} from "reactstrap";
const { Option } = Select;
const DropDown = ({
  dropdownOpen,
  toggle,
  className,
  defaultTitle,
  items,
  onItemClick,
}) => {
  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle className={className} caret>
        {defaultTitle}
      </DropdownToggle>
      <DropdownMenu>
        {items &&
          items.map((i, index) => (
            <DropdownItem key={index} onClick={() => onItemClick(i)}>
              {i}
            </DropdownItem>
          ))}
      </DropdownMenu>
    </Dropdown>
  );
};
const SelectInputDropdown = ({
  type,
  options,
  placeholder,
  className,
  handleChange,
  value,
  style,
  size,
}) => {
  return (
    <>
      <Input
        name="select"
        type={type}
        className={className}
        onChange={handleChange}
        value={value}
        style={style}
        size
      >
        {placeholder && <option>{placeholder}</option>}
        {options?.map((i, index) => (
          <option value={i.value} key={index}>
            {i.label}
          </option>
        ))}
      </Input>
    </>
  );
};
const CustomerDropdown = ({
  label,
  showSearch,
  value,
  options,
  width = "150px",
  onChange,
  fontSize = "16px",
  object_key,
  selected,
  height = "60px",
  customClassName,
  disabled,
  loading,
  ...rest
}) => {
  const labelLines = label?.split("\n")?.length;
  const labelHeight = height * labelLines;
  return (
    <div>
      {label && (
        <div className="pb-2 fw-bold" {...rest}>
          {label}
        </div>
      )}
      <Select
        size="large"
        className={customClassName}
        style={{
          height: height,
        }}
        disabled={disabled}
        value={value}
        onChange={onChange}
        filterOption={(input, option) => {
          return (option?.children ?? "")
            .toLowerCase()
            .includes(input.toLowerCase());
        }}
        showSearch={showSearch}
        loading={loading}
        notFoundContent={loading ? <Spin size="small" /> : null}
        {...rest}
      >
        {options?.map((option, index) => {
          if (object_key == "customer") {
            return (
              <Option key={index} value={selected}>
                {`${option.id} ${option?.billing[0]?.company
                    ? option?.billing[0]?.company
                    : `${option?.billing[0]?.first_name} ${option?.billing[0]?.last_name} (B2C)`
                  }`}
              </Option>
            );
          } else if (object_key == "vendor") {
            return (
              <Option key={index} value={selected}>
                {`${option["id"]} - ${option["first_name"]} ${option["last_name"]}`}
              </Option>
            );
          } else if (object_key == "sku") {
            return (
              <Option key={index} value={selected}>
                {option?.sku}
              </Option>
            );
          } else if (object_key == "rates") {
            const price =
              option?.ratedShipmentDetails[0]?.ratedPackages[0]
                ?.packageRateDetail?.netCharge;
            return (
              <Option key={index} value={selected}>
                {`$${price} ${option["serviceName"]} - ${option["packagingType"]}`}
              </Option>
            );
          } else if (object_key == "number") {
            return (
              <Option key={index} value={selected}>
                {`${option.id}`}
              </Option>
            );
          } else if (object_key == "mfg") {
            return (
              <Option
                key={index}
                value={option?._id}
              >{`${option.id}-${option.name}`}</Option>
            );
          } else if (object_key == "category") {
            return (
              <Option
                key={index}
                value={option?._id}
              >{`${option.id}-${option.categoryName}`}</Option>
            );
          } else if (object_key == "sub-category") {
            return (
              <Option
                key={index}
                value={option?._id}
              >{`${option.id}-${option.subCategoryName}`}</Option>
            );
          } else if (object_key == "user") {
            return (
              <Option
                key={index}
                value={option?._id}
              >{`${option.username}`}</Option>
            );
          } else {
            return (
              <Option key={index} value={option}>
                {option}
              </Option>
            );
          }
        })}
      </Select>
    </div>
  );
};
export { DropDown, SelectInputDropdown, CustomerDropdown };
